export default "/images/master-card.png";